import { render, staticRenderFns } from "./information-index.vue?vue&type=template&id=1945dab2"
import script from "./information-index.vue?vue&type=script&lang=js"
export * from "./information-index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports